import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const LinkIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = '#334155',
  fill = '#fff'
}) => (
  <SVGUniqueID>
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#a)">
        <path
          d="M8.334 10.833a4.165 4.165 0 0 0 6.284.45l2.5-2.5a4.167 4.167 0 0 0-5.892-5.891L9.793 4.317m1.875 4.85a4.167 4.167 0 0 0-6.284-.45l-2.5 2.5a4.166 4.166 0 0 0 5.892 5.891l1.425-1.425"
          stroke={stroke}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={fill} d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { LinkIcon };
